import React,{Component} from 'react';
import {Pie} from 'react-chartjs-2';

class PieChart extends Component{
    constructor(props){
        super(props);
        this.state={
            labels:this.props.labels,
            data:this.props.data
        }
    }
    componentWillReceiveProps(newProps){
        this.setState({
            ...this.state,
            labels:newProps.labels,
            data:newProps.data
        });
    }
   
    style={
        wrapper:{
            backgroundColor:'#029bb4',
            padding:'25px',
            width:'400px',
            display:'flex',
            justifyContent:'space-around',
            borderRadius:'10px',
        },
    }
    render(){
        this.data={
            labels:this.state.labels,
            datasets: [{
                label: "My First dataset",
                backgroundColor: this.props.colors,
                borderColor: 'transparent',
                data:this.state.data,
            }]
        }
        this.options={
            title:{
                display:true,
                text:this.props.title,
                fontColor:'#fff',
                fontSize:16,
                fontFamily:'arial'
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true,
                        display:false,
                        fontColor:'#fff'
                    },
                    gridLines:{
                        display:false,                    color:'transparent'
                    },
                    scaleLabel:{
                        display:false,
                        labelString:this.props.yLabel,
                        fontColor:'#fff',
                        fontSize:16,
                        maxRotation:0
                    },
                    
                }],
                xAxes:[{
                    gridLines:{
                        display:true,
                        color:'transparent'
                        // color:['#fff','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent','transparent']
                    },
                    ticks: {
                        beginAtZero:true,
                        display:false,
                        fontColor:'#fff'
                    },
                    scaleLabel:{
                        display:false,
                        labelString:this.props.xLabel,
                        fontColor:'#fff',
                        fontSize:16,
                    }
                }]
            },
            legend:{
                display:true,
                position:'bottom',
                labels:{
                    fontColor:'#fff',
                    fontSize:16
                }
            }
        }
        return(
            <div style={{...this.style.wrapper,...this.props.style}}>
               <div style={{width:'50px'}}></div> <div style={{height:'300px',width:'300px'}}><Pie width={400} height={400} data={this.data} options={this.options}/></div><div style={{width:'50px'}}></div>
            </div>
        );
    }
}

export default PieChart;